<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <div class="float-right">          
          <b-form-checkbox
            v-model="isRateLimit"
            :value="true"
            class="custom-control-success"
          >
            Es tarifa límite
          </b-form-checkbox>
        </div>

        <div v-if="room.promoCodeManual != ''">
          <div>
            <strong>Tarifa inicial :</strong>
            <b-badge variant="warning">
              <strong> ${{ bookingSelected.rateInit }} </strong>
            </b-badge>
          </div>
          <div>
            <strong>Tarifa Manual:</strong>
            <b-badge
              variant="warning"
              :class="
                room.detailSelected.priceMatchTax != '' ? 'underline-price' : ''
              "
            >
              ${{ room.priceInit }}
            </b-badge>
          </div>
        </div>

        <div v-else>
          <div>
            <strong>Tarifa inicial:</strong>
            <b-badge
              variant="warning"
              :class="
                room.detailSelected.priceMatchTax != '' ? 'underline-price' : ''
              "
            >
              ${{ room.priceInit }}
            </b-badge>
          </div>
        </div>
        <div v-if="room.detailSelected.PromotionName != ''">
          <strong>Promoción: </strong>{{ room.detailSelected.PromotionName }}
        </div>

        <div v-if="room.showingRates">
          <strong>Tarifa Manual:</strong> ${{ room.detailSelected.manualPrice }}
        </div>
        <!-- <div v-if="room.detailSelected.priceMatchTax != ''">
          <strong>Tarifa con promoción: </strong>${{room.detailSelected.priceMatchTax }} 
        </div> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group :label="'Divisa: ' + room.detailSelected.divisa.code">
          <b-form-select v-model="room.detailSelected.divisa">
            <option v-for="cur in currencies" :key="cur.id" :value="cur">
              {{ cur.code }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="8">
        <b-form-group label="Tarifa" v-if="!isLoadingRates">
          <b-form-input
            placeholder="Tarifa"
            type="text"
            @keypress="onlyNumber"
            @change="setManualPrice"
            v-model="room.detailSelected.manualPrice"
          />
        </b-form-group>
        <div class="text-center" v-if="isLoadingRates">
          <b-spinner label="Loading..." variant="success" /><br />
          <strong>Buscando tarifa</strong>
        </div>
      </b-col>
    </b-row>   
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b-badge variant="success">
          <feather-icon icon="DollarSignIcon" class="mr-25" />
          <span>{{ precioConversion }} </span>
      </b-badge>
      <b-button
        
        variant="primary"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        title="Buscar por tarifa manual"
        :disabled="
          room.detailSelected.manualPrice == '' || !room.showingRates
        "
        @click="checkPriceMatchByManualRate"
        ><feather-icon icon="SearchIcon" />
      </b-button>
    </div>
    <div v-if="!isLoadingRates">
  <div 
    v-if="room.detailSelected.PromotionName != '' && isRateLimit "  
    class="d-flex justify-content-between align-items-center mt-2 "
  >
    <div >
      <ValidationProvider name="Comprobante para autorización">
        <b-form-group label="Comprobante para autorización (opcional)" slot-scope="{ valid, errors }">
          <b-form-file
            v-model="file"
            @input="setImgFile(file)"
            placeholder="Adjunte una o más imagenes como evidencia..."
            drop-placeholder="Drop file here..."
            :state="errors[0] ? false : (valid ? true : null)"
            browse-text="Buscar imagen"
            :disabled="isAuthorizingRate"
            multiple
          />
          <b-form-invalid-feedback>{{ errors[0] ? 'Se debe adjuntar la evidencia para la autorización' : '' }} </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <b-card-text class="my-1">
        {{fileMessage}} <strong v-for="f in file" :key="f.name">{{ f ? f.name : '' }},&nbsp;</strong>
      </b-card-text>
    </div>
    <b-button      
      variant="primary"
      @click="handlerUpdateBooking"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-tooltip.hover.top="'Autorizar tarifa manual'"
    > 
     
        <feather-icon
          icon="UnlockIcon"
          size="16"
        /> Actualizar
    
    </b-button>
  </div>
  <div
    v-if="room.detailSelected.PromotionName != '' && !isRateLimit "
    class="d-flex justify-content-end align-items-center"
  >
    
    <b-button          
      variant="primary"
      @click="handlerUpdateBooking"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-tooltip.hover.top="'Tarifa límite'"
    > <feather-icon icon="UnlockIcon"/> Autorizar</b-button>
  </div>
</div>
  
    <AuthorizeUpdateBooking
      :room="room"
      @set-payload-update-booking="setPayloadUpdateBooking"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { toJson, toDecimal, currentDate, showAlertMessage, filterFilesByType, filterFilesBySize, filterFilesByName 
} from "@/helpers/helpers";
import Ripple from "vue-ripple-directive";
import AuthorizeUpdateBooking from "@/modules/mySales/components/orderDetail/bookings/AuthorizeUpdateBooking";

export default {
  directives: {
    Ripple,
  },
  props: {
    room: {
      type: Object,
      required: true,
    },
    isLoadingRates: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AuthorizeUpdateBooking,
  },
  data() {
    return {
      isRateLimit: false,       
      file: null,    
      isAuthorizingRate: false
    };
  },
  computed: {
    ...mapState("start", ["currencies"]),
    ...mapState("mySales", [
      "bookingSelected",
      "orderDetail",
      "searchForm",
      "userAuthUpdateBooking",
    ]),
    ...mapState("auth", ["user"]),
    precioConversion() {
      const precioToUse =
        this.room.detailSelected.priceMatchTax != ""
          ? this.room.detailSelected.priceMatchTax
          : this.room.detailSelected.AmountAfterTax;
      const conversion = precioToUse * this.room.detailSelected.divisa.value;
      return toDecimal(conversion);
    },
    fileMessage(){
      return !this.file?.length ? '' : this.file?.length > 1 ? 'Imagenes seleccionadas:' : 'Imagen seleccionada:'
    }
  },
  methods: {
    ...mapActions('bookings',['authorizeRateUser']),
    ...mapMutations('mySales', ['setManualPriceSelectedRoom', 'setUserAuthorizationUrl']),
    setImgFile(file){
      if(file) this.file = file
      else {
        const text = `😪😪 Tiene que adjuntar un archivo de tipo imagen`
        showAlertMessage( 'No hay imagen', 'InfoIcon', text, 'danger', 4000, 'bottom-right')
      }
    },
    setManualPrice() {
      const keyRoom = this.room.keyRoom;
      const manualRate = this.room.detailSelected.manualPrice;
      const payload = { keyRoom, manualRate };
      this.setManualPriceSelectedRoom(payload);
    },
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        event.preventDefault();
      }
    },
    checkPriceMatchByManualRate() {
      const manualRate = parseFloat(this.room.detailSelected.manualPrice);
      const { hoteldinguscode, language } = this.bookingSelected;
      const { dateIn, dateOut, RoomTypeCode } = this.room;
      const { ninos, adults, children } = this.searchForm;
      let arrayNinios = [];
      if (ninos && ninos.length > 0) {
        ninos.forEach((edad) => {
          arrayNinios.push(edad);
        });
      }
      
      let comision =toJson([...this.orderDetail.bookings.filter(item => item.booking.id === this.room.id )])
      this.room.detailSelected.allowPriceMatch = true;
      const payload = {
        adults,
        children,
        dateIn,
        dateOut,
        hotel: hoteldinguscode,
        idioma: language,
        isManualRate: true, // en true para price match manual price
        keyRoom: this.room.keyRoom, //lo ocupo de manera interna
        manualRate, //requirido para price match manual price
        ninos: toJson(arrayNinios),
        priceInit: parseFloat(this.room.detailSelected.priceInit), //lo ocupo de manera interna, no necesario para el request
        promotionCode: "",
        rate: parseFloat(this.room.detailSelected.priceInit), //requirido para price match manual price
        rateplanid: "",
        roomCode: RoomTypeCode,
        tarifa: this.room?.detailSelected?.RatePlanCode || "", // Es requerido,
        vendorcode: this.user?.canalventa?.dingusvendorcode || "",
        serviceFee: comision.length > 0 ? comision.serviceFee : 0
      };
      console.log( payload )
      this.$emit("check-price-match-by-promotion-code", payload)
    },
    async handlerUpdateBooking() {
      if( !this.isRateLimit ) {
        this.openModal()
      }
      if( this.isRateLimit ) {
        const payload = {
          authorizationUser: null,
          dateAuthorization: null,
          isAuthorization: false,
          isRateLimit: true,
          requiresAuthorization: false,
          urlAuthorization: null,
        }
        if (this.file && this.file.length > 0) {   

          const validFiles = this.validateFiles()
          if (!validFiles) return  

          const payloadAutorize = { user: this.user.idUser, code: null, username: this.user.username, file: this.file, isPriceMatch: false }
          this.isAuthorizingRate = true
          const url = await this.authorizeRateUser(payloadAutorize) 
          this.isAuthorizingRate = false
          if( url ){
            this.setUserAuthorizationUrl(url)
          }
          payload.authorizationUser = this.user.idUser
          payload.dateAuthorization = currentDate()
          payload.isAuthorization = true 
          payload.urlAuthorization = url
        }
        this.file = null      
        this.$emit("update-booking", payload)                
      }
    },
    setPayloadUpdateBooking() {
      const { idUser, urlAuthorization } = this.userAuthUpdateBooking;
      this.closeModal();
      const payload = {
        authorizationUser: idUser,
        dateAuthorization: currentDate(),
        isAuthorization: true,
        isRateLimit: this.isRateLimit,
        urlAuthorization,
      };
      this.$emit("update-booking", payload);
    },
    openModal() {
      this.$root.$emit("bv::show::modal", "update-booking" + this.room.keyRoom);
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", "update-booking" + this.room.keyRoom);
    },
    validateFiles(){
      if (this.file.length > 5) {
        this.file = null
        showAlertMessage( 'Maximo alcanzado', 'InfoIcon', 'No puedes subir más de 5 archivos', 'warning', 4000, 'bottom-right')
        return false
      }
      const filteredByType = filterFilesByType(this.file)
      if (!filteredByType) return false

      const filteredBySize = filterFilesBySize(filteredByType, 2202009.6)
      if (!filteredBySize) return false

      const filteredByName = filterFilesByName(filteredBySize)
      if (!filteredByName) return false

      return true
    }
  },
};
</script>
